/** * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Events namespace agreement - [namespace:module|kind:action] like [sdk:track:play] or [widget:song:onload]
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * **/

import { SDKEvent, SDKCustomEvent } from '..'
import { EVENT_PLAYBACK_STATUS } from '../../constants/enums'

/** * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *                                Events List
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * **/

export const SDK_CONFIGURATION_START = new SDKEvent('sdk:configuration:start')
export const SDK_CONFIGURATION_END = new SDKEvent('sdk:configuration:end')
export const SDK_CONFIGURATION_ERROR = new SDKEvent('sdk:configuration:error')

export const SDK_AUTH_START = new SDKEvent('sdk:auth:start')
export const SDK_AUTH_END = new SDKEvent('sdk:auth:end')
export const SDK_AUTH_ERROR = new SDKEvent('sdk:auth:error')
export const SDK_AUTH_POPUP_OPEN = new SDKEvent('sdk:auth:popup:open')
export const SDK_AUTH_POPUP_CLOSE = new SDKEvent('sdk:auth:popup:close')
export const SDK_POPUP_BLOCKED = new SDKEvent('sdk:auth:popup:blocked')
export const SDK_AUTH_SESSION_CHANGED = new SDKEvent('sdk:auth:session:changed')

export const SDK_STATE_READY = new SDKEvent('sdk:state:ready')
export const SDK_STATE_ERROR = new SDKEvent('sdk:state:error')

export const SDK_CONCURRENT_PLAYBACK_START = new SDKEvent('sdk:playback:start')
export const SDK_CONCURRENT_PLAYBACK_STOP = new SDKEvent('sdk:playback:stop')

export const SDK_OIDC_TOKEN_FETCH_START = new SDKEvent('sdk:token:fetch:start')
export const SDK_OIDC_TOKEN_FETCH_END = new SDKEvent('sdk:token:fetch:end')

/** * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *                                CustomEvents List
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * **/

export const SDK_AUTH_STATUS_CHANGE = (isAuthorized: boolean): SDKCustomEvent<{ isAuthorized: boolean }> =>
  new SDKCustomEvent(SDK_AUTH_STATUS_CHANGE.type, { detail: { isAuthorized } })
SDK_AUTH_STATUS_CHANGE.type = 'sdk:auth:status:change'

export const SDK_PLAYBACK_TRACK_CHANGE = (status: EVENT_PLAYBACK_STATUS) =>
  new SDKCustomEvent(SDK_PLAYBACK_TRACK_CHANGE.type, { detail: { status } })
SDK_PLAYBACK_TRACK_CHANGE.type = 'sdk:playback:track:change'


export const SDK_CHROMECAST_STATUS_CHANGE = (isAvailable: boolean) => new SDKCustomEvent(SDK_CHROMECAST_STATUS_CHANGE.type, { detail: { isAvailable } })
SDK_CHROMECAST_STATUS_CHANGE.type = 'sdk:chromecast:status:change'
export const SDK_CHROMECAST_CONNECTED = new SDKEvent('sdk:chromecast:session:connected')
export const SDK_CHROMECAST_CONNECTING = new SDKEvent('sdk:chromecast:session:connecting')
export const SDK_CHROMECAST_DISCONNECTED = new SDKEvent('sdk:chromecast:session:disconnected')
export const SDK_CHROMECAST_CONNECTION_ERROR = (code: string) => new SDKCustomEvent(SDK_CHROMECAST_CONNECTION_ERROR.type, { detail: { code } })
SDK_CHROMECAST_CONNECTION_ERROR.type = 'sdk:chromecast:session:failure'
